import { render, staticRenderFns } from "./tableDocumentType.vue?vue&type=template&id=41185f6b&"
import script from "./tableDocumentType.vue?vue&type=script&lang=js&"
export * from "./tableDocumentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports